// src/components/RequireAuth.jsx
import React, { useEffect } from "react";
import { useAuth } from "./AuthProvider";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading && (!user || user.id === "guest")) {
      const back = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?next=${back}`;
    }
  }, [loading, user]);

  if (loading) return <div className="p-6 text-sm">Caricamento…</div>;
  if (!user || user.id === "guest") return null;
  return children;
}
